export enum ProductTypeEnum {
  BANKING = 'banking',
  INVESTING = 'investing',
}

export enum BankingSubProductTypeEnum {
  CHECKING = 'CHECKING',
  SAVINGS = 'SAVINGS',
  MONEY_MARKET = 'MONEY_MARKET',
  CASH_MANAGEMENT = 'CASH_MANAGEMENT',
  CD = 'CD',
  CHECKING_SAVING_CDS = 'CHECKING_SAVING_CDS',
  CHECKING_SAVING = 'CHECKING_SAVING',
}

export enum EntityPlacementCtaTypeEnum {
  ApplyNow = 'APPLY_NOW',
  ApplyNowButton = 'APPLY_NOW_BUTTON',
  Prequal = 'PREQUAL',
  ReadReview = 'READ_REVIEW',
  ProductImage = 'PRODUCT_IMAGE',
  ProductName = 'PRODUCT_NAME',
  RestOfProductCard = 'REST_OF_PRODUCT_CARD',
}

export enum MarketplaceEntityTypeEnum {
  Institutions = 'institutions',
  Offers = 'offers',
  Products = 'products',
}

export enum EntityTypeEnum {
  offers = 'offer',
  institutions = 'institution',
  products = 'product',
}

export enum MonetizableEnum {
  yesAssumed = 'yes_assumed',
  no = 'no',
  noBecauseOfDetails = 'no_because_of_details',
  noBecauseOfLead = 'no_because_of_lead',
  noBecauseOfLeadForm = 'no_because_of_lead_form',
  noBecauseOfLimit = 'no_because_of_limit',
}

export enum MarketplaceStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Archived = 'ARCHIVED',
}
